import React, { useEffect } from 'react';

const MangaImageLightbox = ({ src, alt, onClose }) => {
    useEffect(() => {
        if (!src) {
            return undefined;
        }
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose?.();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [src, onClose]);

    if (!src) {
        return null;
    }

    return (
        <div className="manga-lightbox" onClick={onClose}>
            <div className="manga-lightbox-content" onClick={(event) => event.stopPropagation()}>
                <img src={src} alt={alt || 'Обложка манги'} />
                <button type="button" className="button-sec" onClick={onClose}>
                    Закрыть
                </button>
            </div>
        </div>
    );
};

export default MangaImageLightbox;
